import type { ChangeEvent } from "react";
import { useState } from "react";
import type { ChatCompletionsRequestObject } from "../../../services/api/instances/completionsApi/types";
import { selectCompliance } from "../../../services/redux/complianceSlice/selectors";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { createChat } from "../redux/actions";
import { selectMessageLoading, selectMessages } from "../redux/selectors";
import { setMessages } from "../redux/slice";
import { TModelItem } from "../../../services/api/instances/modelsApi/types";

export const useChatCompletions = () => {
  const dispatch = useAppDispatch();
  const compliance = useAppSelector(selectCompliance);
  const messages = useAppSelector(selectMessages);
  const isMessageLoading = useAppSelector(selectMessageLoading);
  const [userMessage, setUserMessage] = useState<string>("");
  const [selectedModel, setSelectedModel] = useState<TModelItem | null>(null);

  const handleChangeMessage = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setUserMessage(e.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.ctrlKey && event.key === "Enter") {
      event.preventDefault();
      handleSendChatMessage();
    }
  };

  const handleSelectModel = (model: TModelItem | null) => {
    setSelectedModel(model);
  };

  const handleSendChatMessage = () => {
    const postObject = {
      model: selectedModel?.id,
      messages: [
        { role: "system", content: `${compliance}` },
        ...messages,
        { role: "user", content: userMessage },
      ],
    };
    dispatch(setMessages(postObject.messages));
    dispatch(createChat(postObject as ChatCompletionsRequestObject));
    setUserMessage("");
  };

  return {
    selectedModel,
    messages,
    userMessage,
    isMessageLoading,
    handleSelectModel,
    handleKeyDown,
    handleChangeMessage,
    handleSendChatMessage,
  };
};
